import ApiBase from './ApiBase';

export default class ShareAPIs extends ApiBase {
  public fetchShare(shareId: string): Promise<any> {
    return this.get(`/v1/shares/${shareId}`);
  }
}
